import { ParcelData } from './parcelData';
import { Languages } from './languages';

export const Data: ParcelData[] = [
  {
    Date_First_Delivery_Trial:"2021-02-02 12:00:00",
    DatumObjed:"2021-02-01 13:26:00",
    DatumPrevz:"2021-02-01 15:00:00",
    DatumDoruc:"2021-02-02 12:00:00",
    Zasielka_Kod:21020128091,
    hlavnyStatus: "Delivered",
    detailnyStatus:"in good condition",
    DateEstimatedDelivery:"2021-02-02 11:00:00",
    stav: "OK"
  }
];


export const langEN: Languages = 
  {
    insertShipNumber:"Please insert shipment number",
    insertShipNumberPlaceholder:"begins with 1xx or 2xx",
    showStatusButton:"Track the shipment",
    
    shipmentNumber: "Shipment number",
    noteClient: "Note client",
    dateOrder: "Date order",
    currentStatus: "Current status",
    onDeliveryFrom: "On delivery from",
    delivered: "Delivered",
    whoTook: "Who took over",
    previousDelivery: "Previous delivery attempts",
    previousDeliveryDate: "Date",
    previousDeliveryReason: "Reason for non-delivery",

    noData1: "The shipment was not found.",
    noData2: "Please check that you have entered the correct number.",

    badInput: "You probably entered the wrong shipment number.<br>The correct number starts with 1x and contains 10 digits<br>or starts with 2x and contains 11 digits."


  }
;

export const langSK: Languages = 
  {
    insertShipNumber:"Zadajte prosím číslo zásielky",
    insertShipNumberPlaceholder:"začína na 1xx alebo 2xx",
    showStatusButton: "Zobraziť stav zásielky",
    
    shipmentNumber: "Číslo objednávky",
    noteClient: "Poznámka klienta",
    dateOrder: "Objednaná",
    currentStatus: "Aktuálny stav zásielky",
    onDeliveryFrom: "Na doručení od",
    delivered: "Doručená",
    whoTook: "Prevzal",
    previousDelivery: "Predchádzajúce pokusy o doručenie",
    previousDeliveryDate: "Dátum",
    previousDeliveryReason: "Dôvod nedoručenia",

    noData1: "Zásielka sa nenašla.",
    noData2: "Skontrolujte prosím, či ste zadali jej správne číslo.",

    badInput: "Zrejme ste zadali nesprávne číslo zásielky.<br>Správne číslo začína na 1x a obsahuje 10 číslic<br>alebo začína na 2x a obsahuje 11 číslic."

  }
;